(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CollapsibleAnnouncement extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.announcement-collapsible__bar');
      this.toggleButton = this.querySelector('.announcement-collapsible__toggle');
      this.panel = this.querySelector('.announcement-collapsible__panel');

      if (!this.bar || !this.toggleButton || !this.panel) return;

      this.isSticky = this.dataset.sticky === 'true';
      this.remember = this.dataset.remember === 'true';
      this.storageKey = `announcement-collapsible-${this.dataset.sectionId}`;
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);

      this.onBarClick = this.onBarClick.bind(this);
      this.updateStickyOffset = this.updateStickyOffset.bind(this);

      this.restoreState();

      this.bar.addEventListener('click', this.onBarClick);

      if (this.isSticky) {
        this.updateStickyOffset();

        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(this.updateStickyOffset);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.updateStickyOffset);
        }
      }

      if (this.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) this.setOpen(true, { persist: false });
        });
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this)) this.setOpen(true, { persist: false });
        });
      }
    }

    disconnectedCallback() {
      if (this.bar) this.bar.removeEventListener('click', this.onBarClick);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.updateStickyOffset);
      if (this.isSticky) document.documentElement.style.removeProperty('--announcement-sticky-offset');
    }

    get isOpen() {
      return this.dataset.open === 'true';
    }

    onBarClick(event) {
      if (event.target.closest('a')) return;
      this.setOpen(!this.isOpen);
    }

    setOpen(open, options) {
      const settings = options || {};
      if (open === this.isOpen) return;

      const skipAnimation = settings.animate === false;
      if (skipAnimation) this.classList.add('announcement-collapsible--no-anim');

      this.dataset.open = open ? 'true' : 'false';
      this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        this.panel.removeAttribute('inert');
      } else {
        this.panel.setAttribute('inert', '');
      }

      if (skipAnimation) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.classList.remove('announcement-collapsible--no-anim'));
        });
      }

      if (this.remember && settings.persist !== false && !this.designMode) {
        try {
          localStorage.setItem(this.storageKey, open ? 'true' : 'false');
        } catch (error) {
          // Storage blocked (private browsing) — the choice just isn't remembered
        }
      }

      if (this.isSticky) requestAnimationFrame(this.updateStickyOffset);
    }

    restoreState() {
      if (!this.remember || this.designMode) return;

      let stored = null;
      try {
        stored = localStorage.getItem(this.storageKey);
      } catch (error) {
        return;
      }

      if (stored === null) return;
      this.setOpen(stored === 'true', { animate: false, persist: false });
    }

    updateStickyOffset() {
      document.documentElement.style.setProperty(
        '--announcement-sticky-offset',
        `${Math.round(this.getBoundingClientRect().height)}px`
      );
    }
  }

  if (!customElements.get('collapsible-announcement')) {
    customElements.define('collapsible-announcement', CollapsibleAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-coverflow-slider"] && !Shopify.designMode) return;
  try {
    
     var customcoverflow = new Swiper(".custom-coverflow", {
  effect: "coverflow",
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2.5
  },
  keyboard: {
    enabled: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  spaceBetween: 30,
  loop: false,
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }
});

customcoverflow.slideTo(1, false, false);
  var thumbs = new Swiper ('.custom-coverflow-thumbnail', {
    slidesPerView:'auto',
    spaceBetween: 10,
    centeredSlides: true,
    slideToClickedSlide: true,
});
  customcoverflow.controller.control = thumbs;
thumbs.controller.control = customcoverflow;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-banner"] && !Shopify.designMode) return;
  try {
    
  $(window).scroll(function(e){
      var scrolled = $(window).scrollTop();
      if(scrolled < 750){
          parallax()
      }
  });

  //define parallax function
  function parallax(){
    var scrolled = $(window).scrollTop();
    $('.custom-image-banner').css('background-positionY',(scrolled * -0.5)+'px');
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
